module.exports = __webpack_public_path__ + "static/media/tib_company_logo.53695ea3.png";